import  Vue from 'vue'

export default {
    namespaced: true,
    state: {
        date_active: new Date(),
        month_ru: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
        day_week: ['ПН','ВТ','СР','ЧТ','ПТ','СБ','ВС'],
        add_form: false,
        open_day: null,
        edit_form: false
    },
    getters: {
        date_active(state){
            return state.date_active;
        },
        date_active_text(state){
            let new_date = new Date(state.date_active);

            return state.month_ru[new_date.getMonth()] + ', ' + new_date.getFullYear();
        },
        day_week(state){
            return state.day_week;
        },
        day_in_month(state){
            return state.date_active.daysInMonth();
        },
        days_before(state){
            let new_date = new Date(state.date_active);
            new_date.setDate('1');
            let day_of_week = new_date.getDay();
            if(day_of_week === 0)
                day_of_week = 7;

            return day_of_week - 1;
        },
        days_after(state, getters){
            let remainder = (getters.day_in_month + getters.days_before) % 7;
            if(remainder !== 0)
                return 7 - remainder;
            else
                return 0;
        },
        add_form(state){
            return state.add_form;
        },
        open_day(state){
            return state.open_day
        },
        edit_form(state){
            return state.edit_form
        }
    },
    mutations: {
        PrevMonth(state){
            let  new_month = state.date_active.getMonth();
            let new_year = state.date_active.getFullYear();
            if(new_month < 1){
                new_month = 12;
                new_year--;
            }
            if(new_month < 10)
                new_month = '0' + new_month;

            state.date_active = new Date(new_year + '-' + new_month + '-01');
        },
        NextMonth(state){
            let  new_month = state.date_active.getMonth() + 2;
            let new_year = state.date_active.getFullYear();
            if(new_month > 12){
                new_month = 1;
                new_year++;
            }
            if(new_month < 10)
                new_month = '0' + new_month;

            state.date_active = new Date(new_year + '-' + new_month + '-01');
        },
        OpenAddForm(state){
            state.edit_form = false;

            state.add_form = true;
        },
        OpenEditForm(state){
            state.add_form = false;

            state.edit_form = true;
        },
        CloseForm(state){
            state.add_form = false;
            state.edit_form = false;
        },
        SetOpenDay(state, data){
            state.open_day = data;
        },
        SetActiveDay(state, data) {
            state.date_active = data;
        },
        SetCalendarText(state, data) {
            state.month_ru = data.month;
            state.day_week = data.weekSmall;
        }
    },
    actions: {
        PrevMonth ({commit}) {
            commit('PrevMonth');
        },
        NextMonth ({commit}) {
            commit('NextMonth');
        },
        OpenAddForm ({commit}) {
            commit('OpenAddForm');
        },
        OpenEditForm ({commit}) {
            commit('OpenEditForm');
        },
        SetOpenDay ({commit}, data) {
            commit('SetOpenDay', data);
        },
        SetActiveDay ({commit}, data) {
            commit('SetActiveDay', data);
        },
        CloseForm ({commit}) {
            commit('CloseForm');
        },
        LoadCalendarSmallText ({commit}){
            if(process.env.NODE_ENV !== 'production'){
                return new Promise((resolve, reject) => {
                    Vue.http.get('staticText/calendarSmallText.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('SetCalendarText' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    Vue.http.post('staticText', calendarText)
                        .then(response => response.json())
                        .then(data => {
                            commit('SetCalendarText' ,data);
                            resolve();
                        })
                })
            }
        }
    }
};

let calendarText = {
    month: ["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],
    weekSmall: ["ПН","ВТ","СР","ЧТ","ПТ","СБ","ВС"]
};



// WEBPACK FOOTER //
// ./src/store/modules/calendar_small.js